import { DISP, LBL, cx } from "../../components/msd/ui";
import { customerInGroup } from "../../lib/members";
import { DetailSections, JourneyBody, VehicleBlock } from "./RightRail";

const PANEL = "overflow-hidden rounded-[16px] bg-msd-surface shadow-msd-e1";

// The desk body for a brand with the chat panel off (Super Admin > Feature
// access). Its staff talk to the customer in WhatsApp, so the room the thread
// took goes to the service journey, the work the desk still does, with the
// vehicle and the other sections in a column beside it. Under 1280px the
// column drops below the journey.
export default function Workspace({ group, row, escalation, summary, openSections, onToggleSection }) {
  if (!summary) return null;
  const curIdx = summary.steps.findIndex((s) => s.state === "current");

  return (
    <div className="min-h-0 flex-1 overflow-auto bg-msd-ground" data-testid="desk-workspace">
      <div className="grid grid-cols-[minmax(0,1fr)_340px] items-start gap-5 p-5 max-[1280px]:grid-cols-1 max-[860px]:gap-4 max-[860px]:p-3">
        {/* Not collapsible here, but keeps the section id so the header's
            journey chip still scrolls to it. */}
        <section aria-label="Service journey" data-testid="desk-section-journey" className="min-w-0">
          <div className="mb-3 flex items-baseline justify-between gap-3 px-[2px]">
            <h3 className={cx(DISP, "m-0 text-[17px] font-semibold text-msd-ink")}>Service journey</h3>
            <span className={LBL}>
              {curIdx >= 0 ? curIdx + 1 : summary.done} of {summary.steps.length}
            </span>
          </div>
          <JourneyBody group={group} steps={summary.steps} locked={!customerInGroup(summary.members)} />
        </section>

        <div className="flex min-w-0 flex-col gap-4 text-msd-ink">
          <div className={PANEL}>
            <VehicleBlock group={group} />
          </div>
          <div className={PANEL}>
            <DetailSections
              group={group}
              row={row}
              escalation={escalation}
              summary={summary}
              openSections={openSections}
              onToggleSection={onToggleSection}
              withJourney={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
